import React from 'react';
import TableColumnTitle from '../../../../../components/_table/TableColumnTitle';
import TableFilterInput from '../../../../../components/_table/TableFilterInput';
import TableColumnImg from '../../../../../components/table/TableColumnImg';
import { EVENT_STATUS_TEXT } from '../../../../../constants/service/app/eventConstants';

/**
 *  추천 기획전에 연결된 기획전 아이템 리스트 컬럼
 */
export const columns = (data) => {
  const { isFilter, filterOption, onFilter } = data;

  return [
    {
      title: <TableColumnTitle title={'이미지'} />,
      dataIndex: 'url',
      render: (value) => <TableColumnImg url={value} width={'60px'} height={'60px'} />,
    },
    {
      title: <TableColumnTitle title={'기획전 번호'} filterValue={filterOption.eventId} />,
      dataIndex: 'id',
      className: !isFilter && 'not-filter',
      filterDropdown: ({ confirm }) => (
        <TableFilterInput
          placeholder={'기획전 번호 검색'}
          option={filterOption.eventId}
          confirm={confirm}
          onFilter={(eventId) => onFilter({ eventId })}
        />
      ),
    },
    {
      title: <TableColumnTitle title={'상태'} />,
      dataIndex: 'status',
      render: (value) => EVENT_STATUS_TEXT[value],
    },
    {
      title: <TableColumnTitle title={'제목'} filterValue={filterOption.mainTitle} />,
      dataIndex: 'mainTitle',
      className: !isFilter && 'not-filter',
      filterDropdown: ({ confirm }) => (
        <TableFilterInput
          placeholder={'제목 검색'}
          option={filterOption.mainTitle}
          confirm={confirm}
          onFilter={(mainTitle) => onFilter({ mainTitle })}
        />
      ),
    },
    {
      title: <TableColumnTitle title={'기간'} />,
      dataIndex: 'eventPeriod',
    },
  ];
};
